(function($) {
	'use strict';

	function initializeBlock(blockEl) {
		var self = {
			blockEl: blockEl,
		};

		self.swiperNextEl = self.blockEl.find('.swiper-button-next');
		self.swiperPrevEl = self.blockEl.find('.swiper-button-prev');

		var swiper = new Swiper(self.blockEl.find('.swiper-container').get(0), {
			a11y: window.debAcifer.swiperA11y(),
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},
			},
			loop: true,
			navigation: {
				nextEl: self.swiperNextEl.get(0),
				prevEl: self.swiperPrevEl.get(0),
			},
			slidesPerView: 1,
			spaceBetween: 24,
			speed: 500,
			watchOverflow: true,
		});

		// Each product card is a single link, so slides stay tab-navigable:
		// hide only the loop clones from AT/keyboard, and scroll a card into
		// view when it receives keyboard focus so tabbing advances the slider.
		window.debAcifer.bindSwiperHideDuplicates(swiper);
		window.debAcifer.bindSwiperFocusScroll(swiper);
	}

	$(document).ready(function() {
		$('.deac-block-featured-product-slider').each(function() {
			initializeBlock($(this));
		});
	});

	if (window.acf) {
		window.acf.addAction('render_block_preview/type=deac-featured-product-slider', function(blockEl) {
			initializeBlock(blockEl.find('.deac-block-featured-product-slider'));
		});
	}
})(jQuery);
